
import Header from '@/components/header.vue';
import { defineComponent, ref } from 'vue';
import { Calendar } from 'vant';
import getInfo from '@/http/calenDar';
import router from '@/router';

export default defineComponent({
  components: {
    [Calendar.name]: Calendar,
    Header,
  },
  setup() {
    const dataList: any = ref([]);
    const isShow = ref(false);
    const minDate = ref('');
    getInfo().then((res: any) => {
      dataList.value = res.result;
      minDate.value = res.result[0] ? res.result[0].replace(/-/g, '/') : '';
      isShow.value = true;
    });
    const formatter = (day: any) => {
      // console.log(dataList.value.length);
      const data = day;
      const stingdate: any = `${data.date.getFullYear()}-${
        data.date.getMonth() + 1
      }-${data.date.getDate()}`;
      // console.log(stingdate);
      if (dataList.value.includes(stingdate)) {
        data.bottomInfo = 'ng';
        data.className = 'ng';
      }
      return data;
    };
    // 日期选择
    const onSelect = (data: any) => {
      console.log(data);
      const stingdate: any = `${data.getFullYear()}-${
        data.getMonth() + 1
      }-${data.getDate()}`;
      if (dataList.value.includes(stingdate)) {
        router.push({ path: '/addCase', query: { date: stingdate } });
      }
    };
    return {
      formatter,
      dataList,
      onSelect,
      isShow,
      minDate,
    };
  },
});
